module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bubbletextafteraction":"Tap the microphone button, to ask me a question.","isSpeaking":"Speaking","notSpeaking":"Tap To Talk","isListening":"Listening"},"es":{"bubbletextafteraction":"El reconocimiento de voz está desactivado para el idioma español.","isSpeaking":"Discurso","notSpeaking":"Toca para hablar","isListening":"Escuchando"}}')
  delete Component.options._Ctor
}
